module.exports = __webpack_public_path__ + "img/MIXTRA_BANNER.bedb7bfe.png";